export default "__VITE_ASSET__4LbXHm$r__"